import React, { useState } from "react";
import {
  Alert,
  Button,
  message,
  // Collapse,
  // List,
  Modal,
  Pagination,
  Table,
  Tooltip,
  Input,
  Switch,
  // Typography,
} from "antd";
import { Splitter } from "antd";
import {
  ExpandOutlined,
  CompressOutlined,
  CloseOutlined,
  FormOutlined,
} from "@ant-design/icons";
import CommonTopDetails from "../CommonTopDetails";
import useCommonListing from "../customHooks/useCommonListing";

import {
  // GetFormattedDate,
  GetFormattedDateTime,
} from "../../utils/DateTimeUtils";
import axiosInstance from "../../../api/Axios";
import { useParams } from "react-router-dom";

const BulkCoursesAdd = ({
  open,
  onClose,
  userInfo,
  bundle_id,
  LoadAPI,
  callMain,
  from = "bundle",
  ShowMessage = false,
  userCount = 0,
}) => {
  const [fullscreen, setFullscreen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [assignToAllUsers, setAssignToAllUsers] = useState(false);
  const [selectedRowKeys2, setSelectedRowKeys2] = useState([]);
  const { id } = useParams();
  const columns = [
    {
      title: "Course ID",
      dataIndex: "course_id",
      key: "course_id",
      width: 100,
    },
    {
      title: "Course Title",
      dataIndex: "name",
      key: "name",
      ellipsis: !fullscreen,
      width: 175,
    },
    {
      title: "Type",
      dataIndex: "course_type",
      key: "course_type",
      width: 80,
    },
    { title: "Course Mode", dataIndex: "mode", key: "mode", width: 110 },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      ellipsis: true,
      width: 200,
    },

    {
      title: "Language",
      dataIndex: "language",
      key: "language",
      width: 120,
    },
    ...(fullscreen
      ? [
          {
            title: "Category",
            dataIndex: "category",
            key: "category",
            width: 160,
          },
          {
            title: "Created At",
            dataIndex: "created_at",
            key: "created_at",
            width: 120,
            render: GetFormattedDateTime,
          },
        ]
      : []),
  ];

  let passUrl = "";

  switch (from) {
    case "bundle":
      passUrl = `learn/bundlecontentlist/?bundle_id=${id}&organization=${userInfo?.data?.organization?.id}`;
      break;

    case "course":
      passUrl = `courselist/?organization=${userInfo?.data?.organization?.id}&exclude_role_id=${id}`;
      break;

    case "path":
      passUrl = `learn/learningpathcontentlist/?organization=${userInfo?.data?.organization?.id}&learning_path_id=${id}`;
      break;

    default:
      passUrl = `learn/bundlecontentlist/?bundle_id=${id}&organization=${userInfo?.data?.organization?.id}`;
  }
  const SwitchSubmit = (from) => {
    switch (from) {
      case "bundle":
        return submitData();
      case "course":
        return submitDataRole();
      case "path":
        return submitDataPath();
      default:
        return submitData();
    }
  };
  const {
    data: data2,
    itemsLength: itemsLength2,
    loading: loading2,
    filterData: filterData2,
    onShowSizeChange: onShowSizeChange2,
    onPageChange: onPageChange2,
    handleSearchChange: handleSearchChange2,
    // setFilterData: setFilterData2,
    // handleSwitchChange: handleSwitchChange2,
    // handleClearAll: handleClearAll2,
    // setFilterUrl: setFilterUrl2,
  } = useCommonListing({
    userInfo,
    passSize: 10,
    passPage: 1,
    passURL: passUrl,
    takeFromData:
      from === "bundle" || from === "path"
        ? (res) => res?.data?.data
        : (res) => res?.data?.results,
    loadAgain: open,
  });
  console.log(data2);
  const {
    pageSize: pageSize2,
    currentPage: currentPage2,
    // active: active2,
    // filter_url: filter_url2,
  } = filterData2;

  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");

  const rowSelection2 = {
    selectedRowKeys: selectedRowKeys2,
    onChange: (newSelectedKeys, newSelectedRows) => {
      // Get all keys visible on current page
      const currentPageKeys = data2.map((row) => row.id || row.client_id);

      // Create a Set from current selections
      const updatedKeysSet = new Set(selectedRowKeys2);

      // Remove any deselected keys from current page
      currentPageKeys.forEach((key) => {
        updatedKeysSet.delete(key);
      });

      // Add all newly selected keys
      newSelectedKeys.forEach((key) => {
        updatedKeysSet.add(key);
      });

      // Final merged keys
      const finalKeys = Array.from(updatedKeysSet);
      setSelectedRowKeys2(finalKeys);
    },
  };

  const handleClose = () => {
    console.log("BulkCoursesAdd: Closing modal and resetting state...");
    setFullscreen(false);
    setSelectedRowKeys2([]);
    setRemarks("");
    setAssignToAllUsers(false);
    setConfirmVisible(false);
    setLoading(false);
    onClose();
  };

  const submitData = async () => {
    setConfirmVisible(false);
    setLoading(true);
    console.log("BulkCoursesAdd: Initiating submitData...");
    const payload = {
      course_ids: selectedRowKeys2,
      bundle_id: bundle_id,
      assign_to_all_users: assignToAllUsers,
      remarks: remarks,
    };
    console.log("BulkCoursesAdd: Final Payload:", payload);
    try {
      await axiosInstance.post(
        "learn/bundlecourseassign/",
        payload,
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      console.log("BulkCoursesAdd: Assignment response success");
      message.success("Bulk assignment successful!");
      LoadAPI();
    } catch (error) {
      console.error("BulkCoursesAdd: Assignment failed:", error);
      message.error("Bulk assignment failed. Please try again.");
    } finally {
      setLoading(false);
      callMain();
      handleClose();
    }
  };
  const submitDataRole = async () => {
    setLoading(true);
    try {
      await axiosInstance.post(
        "learn/rolecourse/",
        {
          courses: selectedRowKeys2,
          role: bundle_id,
        },
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      message.success("Bulk assignment successful!");
      LoadAPI();
    } catch (error) {
      message.error("Bulk assignment failed. Please try again.");
    } finally {
      setLoading(false);
      callMain();
      handleClose();
    }
  };

  const submitDataPath = async () => {
    setLoading(true);
    try {
      await axiosInstance.post(
        "learn/learningpathcourseassign/",
        {
          course_ids: selectedRowKeys2,
          learning_path_id: bundle_id,
        },
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      message.success("Bulk assignment successful!");
      LoadAPI();
    } catch (error) {
      message.error("Bulk assignment failed. Please try again.");
    } finally {
      setLoading(false);
      callMain();
      handleClose();
    }
  };
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <span style={{ fontWeight: 600, fontSize: 18 }}>Course Assign</span>
        </div>
      }
      width={fullscreen ? "100vw" : 1300}
      style={fullscreen ? { top: 0, padding: 0, height: "100vh" } : {}}
      styles={{
        body: fullscreen
          ? { height: "calc(100vh - 100px)", overflow: "auto", padding: 0 }
          : { maxHeight: 800, overflow: "auto", padding: 0 },
      }}
      closeIcon={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 16,
            marginRight: 40,
          }}
        >
          <Tooltip title={fullscreen ? "Exit Fullscreen" : "Expand"}>
            <span
              style={{
                cursor: "pointer",
                fontSize: 20,
                color: "#555",
                borderRadius: "50%",
                padding: 4,
                transition: "background 0.2s, color 0.2s",
                background: fullscreen ? "#f0f0f0" : "transparent",
                boxShadow: fullscreen ? "0 0 4px #ccc" : "none",
                display: "flex",
                alignItems: "center",
              }}
              onClick={(e) => {
                e.stopPropagation();
                setFullscreen((prev) => !prev);
              }}
            >
              {fullscreen ? <CompressOutlined /> : <ExpandOutlined />}
            </span>
          </Tooltip>
          <Tooltip title="Close">
            <span
              style={{
                cursor: "pointer",
                fontSize: 20,
                color: "#555",
                borderRadius: "50%",
                padding: 4,
                transition: "background 0.2s, color 0.2s",
                background: "#f0f0f0",
                boxShadow: "0 0 4px #ccc",
                display: "flex",
                alignItems: "center",
              }}
              onClick={(e) => {
                e.stopPropagation();
                handleClose();
              }}
            >
              <CloseOutlined />
            </span>
          </Tooltip>
        </div>
      }
    >
      <div
        style={{
          width: "100%",
          // height: fullscreen ? "calc(100vh - 100px)" : 600,
          overflow: "hidden",
        }}
      >
        {/* {ShowMessage && (
          <Alert
            message={`There are ${userCount} users already in the bundle, so the newly added users will be allotted these courses.`}
            type="info"
            showIcon
          />
        )} */}
        <Splitter style={{ width: "100%" }}>
          <Splitter.Panel
            defaultSize="100%"
            min="20%"
            max="80%"
            className="table-wrapper"
            style={{ overflowX: "auto", overflowY: "hidden" }}
          >
            <CommonTopDetails
              title={"Courses"}
              titleSuffix={`${itemsLength2 || 0} course(s)`}
              searchPlaceholder="Search by ID or Title"
              searchAction={handleSearchChange2}
              marginPass="15px"
              paddingInlinepass="10px"
              showAddButton={false}
              filterAction={false}
              filterUrl={false}
            />
            <Table
              columns={columns}
              dataSource={data2}
              size="small"
              bordered
              rowKey="id"
              className="table-container"
              scroll={{
                x: 200,
                y: fullscreen ? 500 : 400,
              }}
              style={{ marginInline: "1rem" }}
              pagination={false}
              loading={loading2}
              rowSelection={rowSelection2}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "3rem",
                marginInline: "2rem",
                marginBottom: "1rem",
              }}
            >
              <Pagination
                size="small"
                showSizeChanger
                onShowSizeChange={onShowSizeChange2}
                onChange={onPageChange2}
                pageSizeOptions={["5", "10", "15", "30", "50", "100"]}
                current={currentPage2}
                defaultPageSize={pageSize2}
                total={itemsLength2}
              />
              <div
                style={{
                  display: "flex",
                }}
              >
                <Button
                  key="back"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleClose();
                  }}
                  style={{ marginRight: "1rem" }}
                >
                  <CloseOutlined />
                  Cancel
                </Button>

                <Button
                  type="primary"
                  htmlType="submit"
                  onClick={() => {
                    if (from === "bundle") {
                      console.log("BulkCoursesAdd: Triggering confirmation modal...");
                      setConfirmVisible(true);
                    } else {
                      console.log("BulkCoursesAdd: Submitting via SwitchSubmit...");
                      SwitchSubmit(from);
                    }
                  }}
                  disabled={selectedRowKeys2.length === 0}
                  loading={loading}
                >
                  Save Assignment{selectedRowKeys2.length > 1 ? "s" : ""}
                  <FormOutlined />
                </Button>
              </div>
            </div>
          </Splitter.Panel>
        </Splitter>
      </div>
      <Modal
        title={
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <FormOutlined style={{ color: "#1890ff" }} />
            <span>Confirm Bulk Assignment</span>
          </div>
        }
        open={confirmVisible}
        onOk={submitData}
        onCancel={() => {
          setConfirmVisible(false);
          setLoading(false);
        }}
        okText="Confirm & Save"
        cancelText="Cancel"
        confirmLoading={loading}
        centered
        width={450}
      >
        <div style={{ padding: "10px 0" }}>
          <div style={{ marginBottom: "24px" }}>
            <div style={{ fontWeight: 600, marginBottom: "12px", color: "#444" }}>
              Assignment Configuration
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "16px",
                background: "#f0f7ff",
                border: "1px solid #34aff1ff",
                borderRadius: "10px",
                transition: "all 0.3s",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                <span style={{ fontWeight: 500, color: "#1d39c4" }}>
                  Assign to all users?
                </span>
                <span style={{ fontSize: "12px", color: "#666" }}>
                  Enable this to automatically enroll all existing users in the bundle.
                </span>
              </div>
              <Switch
                checked={assignToAllUsers}
                onChange={(checked) => setAssignToAllUsers(checked)}
                checkedChildren="Yes"
                unCheckedChildren="No"
                style={{ minWidth: 65, backgroundColor: assignToAllUsers ? "#1890ff" : "#bfbfbf" }}
              />
            </div>
          </div>

          <div>
            <div style={{ marginBottom: "8px", fontWeight: 500 }}>Remarks</div>
            <Input.TextArea
              rows={4}
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              placeholder="Enter any remarks (optional)"
              style={{ borderRadius: "8px" }}
            />
          </div>
        </div>
      </Modal>
    </Modal>
  );
};

export default BulkCoursesAdd;
